export default __webpack_public_path__ + "static/media/black-king.24d5537d.png";